import React, { Component } from "react";
// import $ from "jquery";
import Apihelpers from "./helper/ApiHelper";
import { NEET_HELP_EMAIL } from "./helper/Constants";



class userDelete extends Component {

  constructor(props) {
    super(props);
    this.state = {
      number: "",
      hasNumberError: null,
      isOTPsend: false,
      iserrormsz:"",
      hasOtpError: null,
      otpNumber:"",
      sucessmsz:"",
      timer:false,
      time:59
    };
  }
  
  callTimer = () => {
    let aa = this.state.time;
    this.interval = setInterval(()=>{
      aa--;
      this.setState({
        time:aa
      });
      if(aa == 0) {
        clearInterval(this.interval);
        this.setState({
          timer:false
        })
      }
    },1000);
  }

  getOTP = () => {
    if (this.state.number.length !== 10) {
        this.setState({
            hasNumberError: true
        })
        return;
    } else {
        this.setState({
            hasNumberError: false
        })
    }
    let objData = {
        mob_number: this.state.number,
        is_resend:false
    };
    console.log('objData',objData);
    
    Apihelpers.postdataresponse('users/remove', objData).then(res => {
        console.log('res',res.data);
        if (res.data.status === true) {
            this.setState({
              isOTPsend:true,
              timer:true,
              time:59
            });
            this.callTimer();
        } else {
            this.setState({iserrormsz:res.data.message});
        }
    });
  }
  verifyOTP = () => {
    if (this.state.otpNumber.length !== 6) {
        this.setState({
            hasOtpError: true
        })
        return;
    } else {
        this.setState({
            hasOtpError: false
        })
    }
    
    let objData = {
        mob_number: this.state.number,
        is_resend:true,
        otp: this.state.otpNumber
    };
    console.log('objData',objData);
    Apihelpers.postdataresponse('users/remove', objData).then(res => {
        console.log('res',res.data);
        if (res.data.status === true) {
            //sucess redirection added
            window.location.href = window.location.origin+'/admin/user-delete/success';
            // this.setState({
            //     iserrormsz:"",
            //     sucessmsz:res.data.message
            // });
        } else {
            this.setState({iserrormsz:res.data.message});
        }
    })
    .catch(err => {
      console.log('err',err);
      window.location.href = window.location.origin+'/admin/user-delete/failure';
    });
  }
  changeOtp = (e) => {
    this.setState({iserrormsz:""});
    let val = e.target.value;
    if(val.length > 6) {
        return;
    }
    this.setState({otpNumber:val})
  }
  chagneNubmer = (e) => {
    this.setState({iserrormsz:""});
    let val = e.target.value;
    if(val.length > 10 || val < 0) {
      return;
    }
    this.setState({number:val});
  }


  render() {
    return (
      <React.Fragment>
        <div className="wrapper">
          <div className="container">
            <div className="flexWrapper">
              <div className="userDeletePage">
                <div className="popUpLogo">
                  <img src="/assets/images/logo.png" alt="" />
                </div>
                <div className="form">
                  <div className="form-group">
                    <h3>Request Account Deletion.</h3>
                    <div className="desc">Note : Account Deletion is Permanent.  By Proceeding ahead you will loose access to all our services and all your data will be deleted. </div>
                  </div>
                    <div className="form-area" style={(this.state.sucessmsz !== "") ? {'display':'none'} : {}}>
                    {
                    this.state.isOTPsend ?
                    <div>
                        <div className="desc-b">
                          Please ener the 6-digit verification code that was sent. <br /> 
                          <span className="counter" style={this.state.timer ? {'display':'block'}:{'display':'none'}}>00 : {this.state.time}</span>
                          {
                            this.state.timer ? '' : <a href="#" onClick={this.getOTP}>Resend OTP</a>
                          }
                        </div>
                        <div className="form-group otp-group">
                            <label className="control-title">Verification code</label>
                            <input className="form-control" type="number" id="otpNumber" autoComplete="off" onChange={(e)=>{this.changeOtp(e)}} value={this.state.otpNumber} />
                            {this.state.hasOtpError == true ? <div className="react-inputs-validation__msg___pxv8o react-inputs-validation__error___2aXSp">Please enter valid otp </div> : ''}
                        </div>
                        <button className="blueBtn" type="button" onClick={this.verifyOTP}>Verify Code</button>
                    </div>
                    :
                    <div>
                        <div className="form-group">
                            <label className="control-title">Number <span>Should be 10 digit</span></label>
                            <input className="form-control" type="number"  id="number" placeholder='Enter phone number' value={this.state.number} autoComplete="off" name="number" onChange={(e)=>{this.chagneNubmer(e)}}  />

                            {this.state.hasNumberError == true ? <div className="react-inputs-validation__msg___pxv8o react-inputs-validation__error___2aXSp">Please enter valid number </div> : ''}
                        </div>
                        <button className="blueBtn" type="button" onClick={this.getOTP} >Get OTP</button>
                    </div>
                    }
                    {this.state.iserrormsz ? <div style={{ color: "red", marginTop: "20px" }}>{this.state.iserrormsz}</div> : ""}
                    </div>

                    {
                        (this.state.sucessmsz !== "") ?
                        <div className="thanksMesg">{this.state.sucessmsz}</div>
                        : ""
                    }
                </div>
                <div className="bottomBg">
                  Need help? <a href={"mailto:" + NEET_HELP_EMAIL}>{NEET_HELP_EMAIL}</a>
                </div>
              </div>
            </div>

          </div>
        </div>
      </React.Fragment>
    )
  }
}

export default userDelete;
